var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUsers = function SvgUsers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#292929",
    d: "M9.16 12.337a4.687 4.687 0 1 0-5.195 0 7.5 7.5 0 0 0-3.69 2.947.626.626 0 1 0 1.048.682 6.25 6.25 0 0 1 10.48 0 .625.625 0 0 0 1.046-.682 7.5 7.5 0 0 0-3.689-2.947m-6.035-3.9a3.438 3.438 0 1 1 6.875 0 3.438 3.438 0 0 1-6.875 0m16.417 7.711a.625.625 0 0 1-.865-.182 6.24 6.24 0 0 0-5.24-2.841.625.625 0 1 1 0-1.25 3.436 3.436 0 0 0 2.774-5.463 3.44 3.44 0 0 0-4.05-1.168.625.625 0 1 1-.464-1.16 4.687 4.687 0 0 1 4.338 8.253 7.5 7.5 0 0 1 3.69 2.947.626.626 0 0 1-.183.864"
  })));
};
export default SvgUsers;